export const palette = {
    primary: {
        regular: '#1f35b5',
        light: '#dfe3f8',
        dark: '#172888',
        text: 'white'
    },
    secondary: {
        regular: '#22cbd3',
        light: '#d3f5f6',
        dark: '#1a989e',
        text: 'white'
    },
    success: {
        regular: '#4ac326',
        text: 'white'
    },
    warning: {
        regular: '#f8c947',
        light: '#FFFEB5',
        dark: '#cdcd85',
        text: '#4b4b4b',
    },
    danger: {
        regular: '#ff4949',
        text: 'white'
    },
    pink: {
        regular: '#eb0679',
        light: '#ef6b7b'
    },
    red: {
        regular: '#eb384d',
        light: '#ff4949'
    },
    status: {
        online: '#55d86b',
        pending: '#f9a435'
    },
    grey: {
        1: '#f5f5f5',
        2: '#ebebeb',
        3: '#e0e0e0',
        4: '#e2e2e2',
        5: '#dedede',
        6: '#dedede',
        7: '#c4c4c4',
        8: '#c1c1c1',
        9: '#acacac',
        10: '#9f9f9f',
        11: '#898989',
        12: '#4b4b4b',
        13: '#2d2d2d',
        14: '#0000004D',
        15: '#c3c3c3'
    },
    aqua: '#03DAC6',
    orange: '#F9A435',
    text: '#4b4b4b',
    background: '#E8EAF8'
};
export const viewports = {
    mobile: '0px',
    modal: '520px',
    desktop: '1096px'
};
export const elevation = {
    iconButton: '0px 1px 3px #00000029',
    menu: '0px 16px 24px #00000033',
};
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning'];
export const Theme = {
    palette,
    viewports,
    elevation
};
//# sourceMappingURL=Theme.js.map